import { render, staticRenderFns } from "./detectedRegion.vue?vue&type=template&id=5fdaa7fd&scoped=true&"
import script from "./detectedRegion.vue?vue&type=script&lang=js&"
export * from "./detectedRegion.vue?vue&type=script&lang=js&"
import style0 from "./detectedRegion.vue?vue&type=style&index=0&id=5fdaa7fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdaa7fd",
  null
  
)

export default component.exports